<template>
  <div>
    <c-d-loading-progress :mensagem="getMensagem" :is-loading="loading"/>
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import CDLoadingProgress from '@/views/pages/commons/loading/CDLoadingProgress'

export default {
    name: 'SobreCompraDireta',
    components: {CDLoadingProgress},
    data: () => {
        return {
            loading: false,
            path: ''
        }
    },
    computed: {
        getMensagem() {
            return `Carregando ${this.path}...`
        }
    },
    beforeRouteUpdate(to, from, next){
        this.path = to.meta.cronosCategoria ? to.meta.cronosCategoria : 'manual'
        this.loading = true

        next()
        setTimeout(() => { this.loading = false }, 1000)
    },
    mounted() {
        this.loading = true
        setTimeout(() => { this.loading = false }, 1000)
    },
}
</script>

<style scoped lang="stylus">

</style>